/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { Inject, Injectable } from '@angular/core';
import { CurateSearchVm } from '../../models/curate-search-vm';
import {
  getCurateSearchOptionsAction,
  searchForCurateSearchAction,
  showAddFittingResultPanelAction,
} from './curate-search-actions';
import { selectCreateSearchOptions } from './curate-search-selector';
import { ICurateSearchFacade } from '../../../../../data-access/src/lib/domain/facades-models/curate-search-facade-interface';

import {
  ADD_FITTING_TAB_FACADE_TOKEN,
  IAddFittingTabFacade,
} from '../../../../../data-access/src/lib/domain/facades-models/add-fitting-tab-facade-interface';
import { BackendService } from '../../../../../utils/src/lib/sysque-backend/backend.service';
import { GlobalConstants } from '../../constants/global-constants';
import { LocalStorageService } from '../../../../../utils/src/lib/local-storage/local-storage.service';

@Injectable({ providedIn: 'root' })
export class CurateSearchFacade implements ICurateSearchFacade {
  constructor(
    private store: Store,
    @Inject(ADD_FITTING_TAB_FACADE_TOKEN) private addFittingTabFacade: IAddFittingTabFacade,
    private backendService: BackendService,
    private localStorageService: LocalStorageService
  ) {}

  notifySearchFor(curateSearchVm: CurateSearchVm, unitType: string) {
    this.store.dispatch(searchForCurateSearchAction({ query: curateSearchVm, unitType: unitType }));
    this.store.dispatch(showAddFittingResultPanelAction({ mode: true }));
  }

  getCreateSearchOptions(): Observable<any> {
    this.store.dispatch(getCurateSearchOptionsAction());
    return this.store.select(selectCreateSearchOptions);
  }

  updateSelectorForResult() {
    this.addFittingTabFacade.notifySelectorChange.next('treeView');
  }
  
  public showRequestNewContent(): void {
    this.backendService.messageHandler.sendRequestAsync(GlobalConstants.ShowRequestNewContent);
  }

  public getLocalStorage(key: string): any {
    return this.localStorageService.getStorage(key);
  }
}
